import React from 'react'
import { Widget } from 'widgets-for-react'
import { any, fromJSX, Updater } from 'widgets-for-react'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, Page, WaitingTimesPage } from '../../cmsPageState'
import { WaitingTimesPageHeader } from './waitingTimesLayout'

export const waitingTimesPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: WaitingTimesPage): Widget<Updater<Page>> => {
    const pageKind = page.waitingFor?.forPage!
    const title = page.waitingFor?.title!
    return any([
      fromJSX(() => (
        <WaitingTimesPageHeader
          breadcrumbs={[
            { title: 'Spaarne Gasthuis', url: '/' },
            { title: 'Wachttijden', url: '/wachttijden' },
          ]}
          image={page.image}
          link={page.link}
          title={title}
        />
      )),
      blocksWidget(acceptVideoCookie, { 
          department: pageKind == 'department' ? { title: title, id: 0 } : undefined, 
          subcentrum: pageKind == 'centrum' ? { title: title, id: 0 } : undefined
      })(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
  }
